import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useEffect, useRef, useState } from "react";

import { useLocalStorage } from "@/react/hooks/utils/useLocalStorage";

interface UseMemberChecklistProps {
  autoOpen?: boolean;
}

export const useMemberChecklist = ({
  autoOpen = true,
}: UseMemberChecklistProps = {}) => {
  const { currentCommunityMember } = usePunditUserContext();

  const [isOpen, setIsOpen] = useState(false);
  const hasAutoOpenedRef = useRef(false);

  const {
    getValue: getMemberChecklistDismissed,
    setValue: setMemberChecklistDismissed,
  } = useLocalStorage<boolean>(
    currentCommunityMember?.id
      ? `member_checklist_dismissed_${currentCommunityMember.id}`
      : undefined,
  );

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);

    if (!open) {
      setMemberChecklistDismissed(true);
    }
  };

  useEffect(() => {
    if (!autoOpen || hasAutoOpenedRef.current || !currentCommunityMember)
      return;

    if (
      !currentCommunityMember.show_welcome_popup &&
      !getMemberChecklistDismissed()
    ) {
      hasAutoOpenedRef.current = true;
      setIsOpen(true);
    }
  }, [autoOpen, currentCommunityMember, getMemberChecklistDismissed]);

  return {
    shouldShowMemberChecklist: !!currentCommunityMember?.show_member_checklist,
    shouldShowMemberChecklistBadge: !isOpen,
    isMemberChecklistOpen: isOpen,
    handleMemberChecklistOpenChange: handleOpenChange,
  };
};
